import {List, Map} from 'immutable'
import {CATEGORY} from '../../../endpoints'
import {apiPublic} from '../../../api'
import types from '../types/categoryList'

export default class categoryList {

  static fetchFirstLevelCategories() {
    return function(dispatch, getState) {

      const lastCategoryFetched = (new Date()).getMilliseconds()

      dispatch({
        type: types.FETCH_FIRST_LEVEL_CATEGORIES,
        payload: {
          categories: List(),
          selected: 1,
          lastCategoryFetched: lastCategoryFetched,
        },
      })

      apiPublic.get(CATEGORY + '/category/' + 1 + '/children')
        .then(response => {
          if (lastCategoryFetched === getState().ui.catalog.categoryList.get('lastCategoryFetched'))
            dispatch(categoryList.fetchFirstLevelCategoriesSuccess(response.data.description))
        }, error => {
          let message = ''
          if (error.response) {
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = 'Algo salió mal, revisá tu conexión a internet'
          } else {
            message = 'Algo salió mal'
          }
          dispatch(categoryList.fetchFirstLevelCategoriesFail(message))
        })
    }
  }

  static fetchFirstLevelCategoriesSuccess(children) {
    return {
      type: types.FETCH_FIRST_LEVEL_CATEGORIES_SUCCESS,
      payload: {
        categories: parseCategories(children),
      },
    }
  }

  static fetchFirstLevelCategoriesFail(error) {
    return {
      type: types.FETCH_FIRST_LEVEL_CATEGORIES_FAIL,
      payload: {
        error,
      },
    }
  }

  static deselectCategory(id) {
    return function(dispatch, getState) {

      const list = getState().ui.catalog.categoryList.get('categories')
      let newList = List()

      let found = false
      list.forEach(innerList => {
        if (found) return
        let updatedInnerList = innerList
        const previouslySelected = innerList.findIndex(item => item.get('ID') === id)
        if (previouslySelected !== -1) {
          updatedInnerList = innerList.update(
            previouslySelected,
            item => item.set('Selected', false),
          )
          found = true
        }
        newList = newList.push(updatedInnerList)
      })

      dispatch({
        type: types.DESELECT_CATEGORY,
        payload: {
          categories: newList,
          selected: getCategorySelected(newList),
          lastCategoryFetched: (new Date()).getMilliseconds(),
        },
      })
    }
  }

  static selectCategory(id, isLeaf) {
    return function(dispatch, getState) {

      const state = getState().ui.catalog.categoryList

      const list = state.get('categories')
      let newList = List()

      let found = false
      list.forEach((innerList, index) => {
        if (found) return
        let updatedInnerList = innerList
        const previouslySelected = innerList.findIndex(item => item.get('Selected') === true)
        if (previouslySelected !== -1) {
          updatedInnerList = innerList.update(
            previouslySelected,
            item => item.set('Selected', false),
          )
        }

        index = updatedInnerList.findIndex(item => item.get('ID') === id)
        if (index !== -1) {
          found = true
          newList = newList.push(updatedInnerList.setIn([index, 'Selected'], true))
        } else {
          newList = newList.push(innerList)
        }
      })

      const lastCategoryFetched = (new Date()).getMilliseconds()

      dispatch({
        type: types.SELECT_CATEGORY,
        payload: {
          categories: newList,
          selected: getCategorySelected(newList),
          lastCategoryFetched: lastCategoryFetched,
        },
      })

      if (isLeaf === true) return

      apiPublic.get(CATEGORY + '/category/' + id + '/children')
        .then(response => {
          if (lastCategoryFetched === getState().ui.catalog.categoryList.get('lastCategoryFetched'))
            dispatch(categoryList.selectCategorySuccess(response.data.description))
        }, error => {
          let message = ''
          if (error.response) {
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = 'Algo salió mal, revisá tu conexión a internet'
          } else {
            message = 'Algo salió mal'
          }
          dispatch(categoryList.selectCategoryFail(message))
        })
    }
  }

  static selectCategorySuccess(children) {
    return {
      type: types.SELECT_CATEGORY_SUCCESS,
      payload: {
        categories: parseCategories(children),
      },
    }
  }

  static selectCategoryFail(error) {
    return {
      type: types.SELECT_CATEGORY_FAIL,
      payload: {
        error,
      },
    }
  }

}

function parseCategories(list) {
  return list.map(c => {
    return Map({
      ID: c.ID,
      Description: c.Description,
      IsLeaf: c.IsLeaf,
      Selected: false,
    })
  })
}

function getCategorySelected(list) {
  let selected = 0
  list.forEach(innerList => {
    const previouslySelected = innerList.findIndex(item => item.get('Selected') === true)
    if (previouslySelected !== -1)
      selected = innerList.get(previouslySelected).get('ID')
  })

  return selected
}



// WEBPACK FOOTER //
// ./src/sections/catalog/actions/categoryList.js